import { Link } from '@inertiajs/react';
import { Clock, AlertTriangle } from 'lucide-react';

interface Props {
  organization_name: string;
  [key: string]: any;
}

export default function Expired({ organization_name }: Props) {
  return (
    <div className="min-h-screen bg-muted flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 dark:bg-red-500/20">
            <AlertTriangle className="h-8 w-8 text-red-600 dark:text-red-400" />
          </div>
          <h2 className="mt-6 text-3xl font-extrabold text-foreground">
            Convite Expirado
          </h2>
        </div>

        <div className="bg-background shadow-lg rounded-lg p-8">
          <div className="space-y-6">
            <div className="text-center">
              <h3 className="text-xl font-semibold text-foreground mb-4">
                {organization_name}
              </h3>
            </div>

            <div className="bg-red-50 border border-red-200 dark:bg-red-500/10 dark:border-red-500/20 rounded-lg p-4 text-center">
              <div className="flex items-center justify-center gap-2 text-red-800 dark:text-red-400 mb-2">
                <Clock className="w-5 h-5" />
                <span className="font-medium">Este convite expirou</span>
              </div>
              <p className="text-red-700 dark:text-red-400 text-sm">
                O prazo para aceitar este convite já passou. Entre em contato com o
                proprietário da organização para solicitar um novo convite.
              </p>
            </div>

            <div className="text-center">
              <Link
                href="/"
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 transition-colors"
              >
                Voltar para a página inicial
              </Link>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center gap-2">
          <img src="/logo-dark.png" alt="StationZero" className="h-5" />
          <span className="text-sm text-muted-foreground">Transforme seu e-commerce com IA</span>
        </div>
      </div>
    </div>
  );
}
